import { render, staticRenderFns } from "./BtnFixedItem.vue?vue&type=template&id=1b624b85&"
import script from "./BtnFixedItem.vue?vue&type=script&lang=js&"
export * from "./BtnFixedItem.vue?vue&type=script&lang=js&"
import style0 from "./BtnFixedItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports